import { useMemo } from 'react';
import type { PortfolioDetailedReturns } from './usePortfolioDetailedReturns';

export const useSortedHoldings = (
  portfolioDetailedReturns?: PortfolioDetailedReturns
) => {
  return useMemo(() => {
    if (!portfolioDetailedReturns)
      return { sortedHoldings: [], sortedLiquidatedHoldings: [] };

    const { holdings, liquidatedHoldings } = portfolioDetailedReturns;

    const sortedHoldings = holdings.sort((a, b) =>
      a.company.name.localeCompare(b.company.name)
    );
    const sortedLiquidatedHoldings = liquidatedHoldings.sort((a, b) =>
      a.company.name.localeCompare(b.company.name)
    );

    return {
      sortedHoldings,
      sortedLiquidatedHoldings,
    };
  }, [portfolioDetailedReturns]);
};
